export default "__VITE_ASSET__$_OFFong__"